import React, { useEffect, useState } from 'react';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const units = [{
    value: h,
    label: 'Hours'
  }, {
    value: m,
    label: 'Minutes'
  }, {
    value: s,
    label: 'Seconds'
  }];
  return <div className="mt-6 rounded-2xl border border-danger/40 bg-danger/10 p-4" role="timer" aria-live="off" data-id="element-19" data-mp="324hx0l5rsuif">
      <p className="text-center font-display text-lg font-bold uppercase tracking-wide text-danger" data-id="element-20" data-mp="373uf6slp5deo">
        The $27 price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-21" data-mp="10a8wwfjcac1m">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-22" data-mp="1592a06ups119" data-mpi={i}>
            <div className="flex w-20 flex-col items-center sm:w-24" data-id="element-23" data-mp="y0esg83rqo4n">
              <span className="w-full rounded-xl bg-ink py-2 text-center font-display text-5xl font-extrabold tabular-nums text-white sm:text-6xl" data-id="element-24" data-mp="t2d69eb1q8oy">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-mist" data-id="element-25" data-mp="12rmzwyljfzf6">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-5xl font-extrabold text-danger sm:text-6xl" data-id="element-26" data-mp="a498th4ity2z">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}